import { Component, Input } from '@angular/core';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

import { ProposalsService } from 'src/app/services/api/proposals.service';

@Component({
  selector: 'proposals-attachments-panel',
  imports: [],
  templateUrl: './proposals-attachments-panel.component.html',
  styleUrl: './proposals-attachments-panel.component.scss'
})
export class ProposalsAttachmentsPanelComponent {
  @Input() proposal: any;
  @Input() attachments: any[] = [];
  @Input() readonlyAttachmentsPanel!: boolean
  @Input() label: string = '';

  selectedFile: File | null = null;
  fileDeleted: any

  constructor(private alertNotificationService: AlertNotificationService, private proposalsService: ProposalsService, private confirmationDialogService: ConfirmationDialogService) {

  }

  ngOnInit(): void {

  }

  onCodeChange(event: any): void {

    this.proposal.code = event.value;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      this.addFile(selectedFile);
      input.value = '';
    }
  }

  viewFile(file: any): void {
    if (file?.url) {
     this.proposalsService.GET(file.url).subscribe({
        next: (response:any) => {
          window.open(response.data.attachment.publicUrl, '_blank');
        }, 
        error: (error:any) => {
          this.alertNotificationService.error('Error downloading file');
          console.error('Error:', error);
        }
      })
    }
    
  }
  confirmDelete(file: any) {
    const message = `Are you confident in your decision to delete this ${file.fileNameOriginal || file.name}?`;
    this.fileDeleted = file;
    this.confirmationDialogService.open(
      message,
      () => this.deleteFile(file)
    );
  }
  deleteFile(file: any): void {
    this.attachments = this.attachments.filter((f: any) => f !== file);
    this.fileDeleted = null;
  }

  addFile(file: File): void {
    const newFile = { name: file.name };
    this.attachments = [...this.attachments, newFile];
    this.alertNotificationService.success('File added successfully')
  }
}
